import { GET_FULL_INVENTORY_LIST } from './getFullInventoryList';
import { GET_INVENTORY_BY_ID } from './getInventoryById';

export * from './types';

export const internalInventoryApi = {
  getById: GET_INVENTORY_BY_ID,
  getFullList: GET_FULL_INVENTORY_LIST,
};
